export enum DevisStatus {
  EN_COURS = 'en_cours',
  VALIDE = 'valide',
  ANNULE = 'annule'
}

export interface DevisItem {
  id: number;
  devis_id: number;
  article_id?: number | null;  // Optional for custom designations
  designation: string;
  quantite: number;
  prix_unitaire: number;
  total: number;
  created_at: string;
}

export interface DevisItemCreate {
  article_id?: number | null;  // Optional for custom designations
  designation: string;
  quantite: number;
  prix_unitaire: number;
  total: number;
}

export interface DevisItemUpdate {
  article_id?: number;
  designation?: string;
  quantite?: number;
  prix_unitaire?: number;
  total?: number;
}

export interface Devis {
  id: number;
  reference: string;
  date: string;
  client_id: number;
  demande_numero?: string;
  remise: number;
  condition_paiement_id?: number;
  mode_paiement_id?: number;
  delai_livraison?: number;
  delai_devis_validation?: number;
  montant_total: number;
  status: DevisStatus | string;
  created_at: string;
  updated_at?: string;
  deleted_at?: string;
  items: DevisItem[];
  // Related names
  client_name?: string;
  client_ice?: string;
  client_address?: string;
  condition_paiement_nom?: string;
  mode_paiement_nom?: string;
  user_id?: number;
  user_name?: string;
  // read by id: its projet and where it stands at the bureau d'études
  projet_id?: number | null;
  projet_code?: string | null;
  projet_be?: { statut: string; statut_label: string; dessinateur: string | null } | null;
}

export interface DevisCreate {
  date: string;
  client_id: number;
  demande_numero?: string | null;
  remise?: number;
  condition_paiement_id?: number | null;
  mode_paiement_id?: number | null;
  delai_livraison?: number | null;
  delai_devis_validation?: number | null;
  items: DevisItemCreate[];
}

export interface DevisUpdate {
  date?: string;
  client_id?: number;
  demande_numero?: string | null;
  remise?: number;
  condition_paiement_id?: number | null;
  mode_paiement_id?: number | null;
  delai_livraison?: number | null;
  delai_devis_validation?: number | null;
  status?: DevisStatus | string;
  items?: DevisItemCreate[];
  /** « Envoyer au bureau d'études » with the validation: its projet goes to the BE */
  envoyer_be?: boolean;
  be_dessinateur_id?: number | null;
  be_instructions?: string | null;
}

export interface DevisListResponse {
  total: number;
  items: Devis[];
}
